var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onCloseImageModal,
          expression: "onCloseImageModal",
        },
      ],
      staticClass: "image-modal-container",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "image-modal-header" }, [
        _vm._v(
          _vm._s(
            _vm.modalComponent === "image-save"
              ? _vm.$t("camstudy.stopwatch.setting.saveImage")
              : _vm.$t("camstudy.stopwatch.setting.changeImage")
          )
        ),
      ]),
      _c("div", { staticClass: "image-modal-body" }, [
        _c("div", { staticClass: "image-container" }, [
          _c("div", { ref: "image-preview", staticClass: "image-preview" }, [
            _c("div", { staticClass: "image-preview-inner-header-container" }, [
              _c(
                "div",
                { staticClass: "image-preview-inner-header-text-container" },
                [
                  _c("div", { staticClass: "today-date" }, [
                    _vm._v(_vm._s(_vm.formatTodayDays)),
                  ]),
                  _c("div", { staticClass: "today-study-time" }, [
                    _vm._v(
                      _vm._s(_vm.$t("camstudy.stopwatch.setting.todayTotal")) +
                        " " +
                        _vm._s(_vm.formatTotalStudyTime)
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.$t("camstudy.stopwatch.setting.studied"))
                    ),
                  ]),
                ]
              ),
              _c("img", {
                staticClass: "grm-logo",
                attrs: {
                  src: require("@/assets/images/camstudy/logo_gooroomee.svg"),
                  alt: "image",
                  crossorigin: "anonymous",
                },
              }),
            ]),
            _c("img", {
              staticClass: "custom-image",
              attrs: {
                src: _vm.getImageUrl,
                alt: _vm.$t("common.image"),
                crossorigin: "anonymous",
              },
            }),
            _c("div", { staticClass: "image-footer-container" }, [
              _c("div", { staticClass: "current-time" }, [
                _vm._v(
                  _vm._s(_vm.$t("camstudy.stopwatch.setting.currentTime")) + " "
                ),
                _c("b", [_vm._v(_vm._s(_vm.formatTimeNow))]),
              ]),
              _c("div", { staticClass: "grm-message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("camstudy.stopwatch.setting.studyWithGooroomee")
                  )
                ),
              ]),
            ]),
          ]),
        ]),
        _vm.modalComponent === "image-save"
          ? _c("div", { staticClass: "image-control-container" }, [
              _c(
                "button",
                {
                  staticClass: "control-button",
                  on: { click: _vm.onChangeComponent },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("camstudy.stopwatch.setting.changeImage"))
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "control-button",
                  on: { click: _vm.onReloadTime },
                },
                [_vm._v(_vm._s(_vm.$t("camstudy.stopwatch.setting.refresh")))]
              ),
            ])
          : _vm.modalComponent === "image-change"
          ? _c(
              "div",
              {
                staticClass: "image-control-container",
                on: { click: _vm.onChangeImage },
              },
              [
                _c("button", {
                  staticClass: "image-control image1",
                  class: { active: _vm.tempSelectedImage === "image1" },
                  attrs: { value: "image1" },
                }),
                _c("button", {
                  staticClass: "image-control image2",
                  class: { active: _vm.tempSelectedImage === "image2" },
                  attrs: { value: "image2" },
                }),
                _c("button", {
                  staticClass: "image-control image3",
                  class: { active: _vm.tempSelectedImage === "image3" },
                  attrs: { value: "image3" },
                }),
                _c(
                  "button",
                  {
                    staticClass: "image-control upload",
                    attrs: { value: "upload" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                      change: _vm.onUploadImage,
                    },
                  },
                  [
                    _c("input", {
                      staticClass: "input-file",
                      attrs: { type: "file" },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm.modalComponent === "image-save"
        ? _c("div", { staticClass: "image-modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "footer-button cancel",
                on: { click: _vm.onCloseImageModal },
              },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "footer-button save",
                on: { click: _vm.onSaveImage },
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
          ])
        : _vm.modalComponent === "image-change"
        ? _c("div", { staticClass: "image-modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "footer-button cancel",
                on: { click: _vm.onChangeComponent },
              },
              [_vm._v(_vm._s(_vm.$t("common.prev")))]
            ),
            _c(
              "button",
              {
                staticClass: "footer-button save",
                on: { click: _vm.onSaveChangeImage },
              },
              [_vm._v(_vm._s(_vm.$t("common.confirm")))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }